<template>
  <div>
    <div class="container">
      <div
        class="error-page flex flex-col lg:flex-row items-center justify-center h-screen text-center lg:text-left"
      >
        <div class="-intro-x lg:mr-20">
          <img
            alt="#"
            class="h-48 lg:h-auto"
            :src="require(`@/assets/images/error-illustration.svg`)"
          />
        </div>
        <div class="text-white mt-10 lg:mt-0">
          <div class="intro-x text-8xl font-medium">404</div>
          <div class="intro-x text-xl lg:text-3xl font-medium mt-5">
            Oops. This page has gone missing.
          </div>
          <div class="intro-x text-lg mt-3">
            You may have mistyped the address or the page may have moved.
          </div>

          <router-link
            :to="{ name: 'admin' }"
            class="intro-x btn py-3 px-4 text-white border-white dark:border-dark-5 dark:text-gray-300 mt-10"
          >
            Back to Home
          </router-link>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {defineComponent, onBeforeUnmount, onMounted} from 'vue';
import cash from "cash-dom/dist/cash";

export default defineComponent({
    setup() {
      onMounted(() => {
        cash('body')
        cash('html')
          .removeClass('main')
          .removeClass('login')
          .addClass('layout-side-menu')
          .addClass('error-page');
      });

      onBeforeUnmount(() => {
        cash('html')
          .removeClass('layout-side-menu')
          .removeClass('error-page')
      });
    },
  });
</script>
